import authAxios from "../authAxios";
import unauthAxios from "../axios";

export const getAffiliateAnalytics = (timeframe) => {
  return authAxios.get("/v1/affiliate/analytics", {
    params: { timeframe },
  });
};

export const getAffiliateReferrals = ({ limit = 10, offset = 0 } = {}) => {
  return authAxios.get("/v1/affiliate/referrals", {
    params: {
      limit,
      offset,
    },
  });
};

export const getAffiliateEarningsSummary = () => {
  return authAxios.get("/v1/affiliate/earnings-summary");
};

export const trackAffiliateView = (affiliateId) => {
  return unauthAxios.get("/v1/affiliate/track-view", {
    params: { affiliate_id: affiliateId },
  });
};

export const trackAffiliateClick = async (affiliateId) => {
  // Check if we've already tracked this affiliate click in localStorage
  const trackedAffiliates = JSON.parse(
    localStorage.getItem("tracked_affiliate_clicks") || "[]"
  );

  // If we haven't tracked this affiliate in the last 24 hours
  if (!trackedAffiliates.includes(affiliateId)) {
    try {
      const response = await unauthAxios.get("/v1/affiliate/track-click", {
        params: { affiliate_id: affiliateId },
      });

      if (response.data.success) {
        // Add to tracked affiliates and store in localStorage
        trackedAffiliates.push(affiliateId);
        localStorage.setItem(
          "tracked_affiliate_clicks",
          JSON.stringify(trackedAffiliates)
        );
      }

      return response;
    } catch (error) {
      console.error("Error tracking affiliate click:", error);
      return { data: { success: false } };
    }
  }

  return { data: { success: true } };
};

export const createAffiliateReferral = (referralData) => {
  return authAxios.post("/v1/affiliate/referral", referralData);
};

export const requestWithdrawal = async (data) => {
  const { bankDetails } = data;
  const response = await authAxios.post("/v1/affiliate/withdrawals", {
    bankDetails,
  });
  return response;
};

export const getWithdrawals = async () => {
  const response = await authAxios.get("/v1/affiliate/withdrawals");
  return response;
};

export const getAffiliateBalances = async () => {
  const response = await authAxios.get("/v1/affiliate/balances");
  return response;
};
